import React, { useEffect, useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ParametrosAPI } from '../../../../shared/http-requests';
import { ModalConstructor } from '../../../../shared/components';

function InfoAsks() {
    const { t } = useTranslation();

    const [faqs, setFaqs] = useState(
        sessionStorage.getItem('faq')
            ? JSON.parse(atob(sessionStorage.getItem('faq')))
            : false,
    );
    const [modal, setModal] = useState(false);
    const [title, setTitle] = useState(null);
    const [content, setContent] = useState(null);

    const open = (title, content) => {
        setTitle(title);
        setContent(content);
        setModal(true);
    };

    useEffect(() => {
        if (!faqs)
            ParametrosAPI.buscaFAQ()
                .then(response => {
                    setFaqs(response.data);
                    sessionStorage.setItem(
                        'faq',
                        btoa(JSON.stringify(response.data)),
                    );
                })
                .catch(console.error);
    }, [faqs]);

    if (faqs && faqs.length)
        return (
            <div className="info__tabs tabs-ask">
                <Row>
                    <Col sm="12" className="animated fadeIn">
                        <Row className="card__header">
                            <Col xs="2" md="2" lg="1">
                                <FontAwesomeIcon
                                    icon="question"
                                    size="5x"
                                    className="icone-header cortxt"
                                />
                            </Col>
                            <Col
                                md="10"
                                lg="11"
                                className="d-none d-md-block card__header__title tabs-ask preto b-w1 b-tema40 pad5 s30 f300"
                            >
                                {t('DuvidasFrequentes')}
                            </Col>
                            <Col
                                xs="10"
                                md="10"
                                className="d-md-none d-block card__header__title tabs-ask preto b-w1 b-tema40 pad5 s20 f400"
                            >
                                {t('DuvidasFrequentes')}
                            </Col>
                        </Row>

                        <Row className="card__holder">
                            <Col
                                xs="10"
                                md="11"
                                className="card__holder__content ml-md-4"
                            >
                                <Row>
                                    {faqs.map(faq => {
                                        return (
                                            <Col
                                                xs="12"
                                                className="s14 mb-2"
                                                key={`faq_row_col${faq.id}`}
                                            >
                                                <span
                                                    onClick={() =>
                                                        open(
                                                            faq.titulo,
                                                            faq.conteudo,
                                                        )
                                                    }
                                                    className="s14 click hover1"
                                                    key={`faq_${faq.id}`}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={[
                                                            'fas',
                                                            'angle-right',
                                                        ]}
                                                        className="s11 r5"
                                                    />
                                                    {faq.titulo}
                                                </span>
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <ModalConstructor
                    closeable
                    closeAction
                    size="xl"
                    title={title}
                    open={modal}
                    setOpen={() => setModal(false)}
                >
                    <div
                        className="px-4"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </ModalConstructor>
            </div>
        );
    return null;
}

export default InfoAsks;
